module.exports = __webpack_public_path__ + "static/assets/f435c118ec64c6f27de575eef30c05de.svg";